module.exports = __webpack_public_path__ + "static/media/play.43b8bdca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/play.svg
// module id = 938
// module chunks = 0